import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const ConnieContext = createContext(null);
export const useConnie = () => useContext(ConnieContext);

const load = (k, def) => {
  try { const v = localStorage.getItem(k); return v === null ? def : JSON.parse(v); } catch { return def; }
};

export const ConnieProvider = ({ children }) => {
  const [hidden, setHidden] = useState(() => load("connie_hidden", false));
  const [hints, setHints] = useState(() => load("connie_hints", true));
  const [dismissed, setDismissed] = useState(() => load("connie_dismissed", []));

  useEffect(() => { localStorage.setItem("connie_hidden", JSON.stringify(hidden)); }, [hidden]);
  useEffect(() => { localStorage.setItem("connie_hints", JSON.stringify(hints)); }, [hints]);
  useEffect(() => { localStorage.setItem("connie_dismissed", JSON.stringify(dismissed)); }, [dismissed]);

  const dismissHint = useCallback((key) => setDismissed((d) => (d.includes(key) ? d : [...d, key])), []);
  const resetHints = useCallback(() => setDismissed([]), []);
  const isDismissed = useCallback((key) => dismissed.includes(key), [dismissed]);

  const value = useMemo(
    () => ({ hidden, setHidden, hints, setHints, dismissHint, resetHints, isDismissed }),
    [hidden, hints, dismissHint, resetHints, isDismissed]
  );

  return (
    <ConnieContext.Provider value={value}>
      {children}
    </ConnieContext.Provider>
  );
};
